/* Application web codée en React par Noé LAROCHE pour EnerVivo
Pour toute question ou renseignement : laroche.noe@orange.fr*/

import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Main.css';
import MapComponent from './MapComponent';
import AddressCompletion from './AddressCompletion';

function Main() {
  const navigate = useNavigate();
  const mapRef = useRef(null);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [selectedParcels, setSelectedParcels] = useState([]);

  const handleButtonClick1 = () => {
    navigate('/');
  };

  const typeHangar = 'pas de hangar, projet agriPV';
  const surfaceHangar = 'pas de surface, projet agriPV';

  const handleButtonClick2 = () => {
    if (totalSurface < 1) {
      setShowErrorMessage(true);
    } else {
      navigate('/etape-2', {
        state: { localisation, totalSurface, typeHangar, surfaceHangar, numParcelles },
      });
    }
  };

  const handleMapClick = (coordinate, params) => {
    // Cette fonction semble inutile dans ce contexte, mais tu peux l'utiliser pour des actions sur la carte.
  };

  useEffect(() => {
    const addressInput = document.getElementById('address-input');
    addressInput.addEventListener('address_selected', (event) => {
      const { latitude, longitude } = event.detail;
      setLocalisation([latitude, longitude]);
      if (mapRef.current) {
        mapRef.current.centerMapTo(latitude, longitude);
      }
    });

    return () => {
      addressInput.removeEventListener('address_selected', () => {});
    };
  }, []);

  const [totalSurface, setTotalSurface] = useState(0);

  const handleSurfaceUpdate = (surface) => {
    setTotalSurface(surface);
  };

  const [numParcelles, setNumParcelles] = useState(0);
  const handleNumParcellesUpdate = (parcelles) => {
    setNumParcelles(parcelles);
  };

 
//ICI C'EST UN AJOUT POUR LA CROIX QUI SUPPRIME LES PARCELLES.

 /*  const handleRemoveParcelle = (parcelleId) => {
    // Supprimer la parcelle de la liste
    const updatedParcels = selectedParcels.filter((id) => id !== parcelleId);
    setSelectedParcels(updatedParcels);

    // Appeler la méthode correspondante du composant MapComponent
    if (mapRef.current) {
      mapRef.current.removeCadastreLayer(parcelleId);
    }
  }; */
//FIN DE L'AJOUT

  const [localisation, setLocalisation] = useState([]);
  const handleLocalisationUpdate = (localisation) => {
    setLocalisation(localisation);
  };

  const safeNumParcelles = Array.isArray(numParcelles) ? numParcelles : [];

  return (
    <div className="home-container">
      <div className="left-container">
        <MapComponent
          ref={mapRef}
          className="map"
          onMapClick={handleMapClick}
          onSurfaceUpdate={handleSurfaceUpdate}
          onNumParcellesUpdate={handleNumParcellesUpdate}
          onLocalisationUpdate={handleLocalisationUpdate}
        />
      </div>
      <div className="right-container">
        <h1>Où se situe votre terrain ?</h1>
        <h2>Entrez votre adresse pour faciliter la sélection de vos parcelles cadastrales</h2>
        <div className="">
          <input
            className="addressbar-input"
            id="address-input"
            type="text"
            placeholder="Recherchez votre adresse..."
          />
          <div id="suggestions-container"></div>
          <AddressCompletion
            containerId="address-input"
            suggestionsContainerId="suggestions-container"
          />
        </div>
        <p></p>
        <h2>Sélectionnez/Déselectionnez vos parcelles en cliquant dessus, tout simplement !</h2>
        <div className="num_parcelles">
          {safeNumParcelles.map((parcelle, index) => (
            <div key={index} className="parcelle_container">
              Parcelle {parcelle}
              {/* <button onClick={() => handleRemoveParcelle(parcelle)} className="icon-button">
                <span className="icon-text">X</span>
              </button> */}
            </div>
          ))}
        </div>
        <div className="surf_parcelles">
          <div>{totalSurface} ha</div>
        </div>
        <br></br>
        <div className="position_boutons_p2">
          <button className="previous-button" onClick={handleButtonClick1}>Précédent</button>
          <button className="next-button" onClick={handleButtonClick2}>
            Suivant
          </button>
        </div>
        {showErrorMessage && (
          <p className="error-message">
            La surface totale doit être supérieure à 1 hectare pour continuer.
          </p>
        )}
      </div>
    </div>
  );
}
export default Main;
